export default "__VITE_ASSET__DHz4kwhX__"